// extracted by mini-css-extract-plugin
export default {"wrapper":"Sba","container":"Tba","box":"Uba","title":"Vba","rdwrap":"Wba","rditem":"Xba","rdimage":"Yba","name":"Zba","heading":"aca","text":"bca","guarantee":"cca","chatbox":"eca"};
    if(module.hot) {
      // 1715632479656
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  